import { Component, OnInit, Inject } from '@angular/core';
import { Sets } from '../set-property-update.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'common-set-params',
	templateUrl: './set-params.component.html',
	styleUrls: ['./set-params.component.scss']
})
export class SetParamsComponent implements OnInit {
	options: any = { maxLines: 12, printMargin: false };
	constructor(public dialogRef: MatDialogRef<SetParamsComponent>, @Inject(MAT_DIALOG_DATA) public set?: Sets) {}

	ngOnInit() {}
}
